import { useState, useEffect, act } from "react";
import "./UploadCheque.css";
import "react-calendar/dist/Calendar.css";
import FPX from "../../assets/icons/fpx-logo.png";
import IBG from "../../assets/icons/ibg-logo.png";
import Select from "react-select";
import Calendar from "react-calendar";
import {
  Upload,
  X,
  Trash2,
  FileText,
  Calendar as LucideCalendar,
  ArrowLeft,
  CreditCard,
  Building2,
  Info,
} from "lucide-react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import ApiService from "../../components/Api_services";
import FallbackImg from "../../components/FallbackImg";
import MultiPurpose from "../../components/multipurpose_v2/MultiPurpose";
import CreditNote from "../../components/creditnote/CreditNote";
import Loading from "../../components/loading/Loading";
import CustomDropdown from "../../components/customdropdown_v2/CustomDropdown";
import Layout from "../../components/layout/Layout";

const UploadChequev2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [paymentSource, setPaymentSource] = useState("invoice");
  const [loading, setLoading] = useState(true);
  const [paymentData, setPaymentData] = useState({
    my_bank_list: [],
    bank_list: [],
    total_payment: "0.00",
    selected_invoices: [],
  });

  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [selectedUnityBank, setSelectedUnityBank] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [value, onChange] = useState(null);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [activeType, setActiveType] = useState(null); // Default to cheque
  const paidBy =
    activeType === "fpx"
      ? "FPX"
      : activeType === "online_banking"
        ? "IBG"
        : "CHEQUE";
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [paymentCompletionType, setPaymentCompletionType] = useState("partial");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [modalLink, setModalLink] = useState("");
  const [modalVariant, setModalVariant] = useState("");
  const [chequeNo, setChequeNo] = useState("");
  const [errors, setErrors] = useState({
    unityBank: "",
    paymentBank: "",
    chequeNo: "",
    chequeDate: "",
    upload: "",
  });
  const [showCreditNote, setShowCreditNote] = useState(false);
  const [selectedCreditNote, setSelectedCreditNote] = useState(null);
  const [bankType, setBankType] = useState("");
  const [fpxBankList, setFpxBankList] = useState([]);
  const [checkoutData, setCheckoutData] = useState(null);
  const [showFpxBank, setShowFpxBank] = useState(false);
  const [fpxStatus, setFpxStatus] = useState("online");
  const formatCurrency = (value) => {
    return parseFloat(value).toLocaleString("en-MY", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatFileSize = (file) => {
    const size =
      file && (typeof file.size === "number" ? file.size : file.fileSize || 0);
    if (!size) return "";
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  };
  const {
    selectedItems,
    paymentType,
    pricingType,
    checkoutMessage,
    customerPO,
    specifiedShippingDate,
    salesmanOpt,
    option,
    extraEinvoiceData,
  } = location.state || {};
  const [showLoading, setShowLoading] = useState(false);
  const [fpxFormData, setFpxFormData] = useState(null);
  const params = new URLSearchParams(location.search);
  const isTermResubmit = params.get("resubmit") === "1";
  const [rejectReason, setRejectReason] = useState("");
  const [checkoutDetailError, setCheckoutDetailError] = useState("");

  useEffect(() => {
    // Helper: normalize an error message whether it comes from a thrown
    // exception or a resolved-but-failed API response
    const getErrMsg = (err, fallback) =>
      err?.response?.data?.message ||
      err?.data?.message ||
      err?.message ||
      fallback;

    const fetchData = async () => {
      setLoading(true);
      try {
        const ids = params.get("ids") || "";
        const cartIds = params.get("cart_ids") || "";
        const orderIds = params.get("orders") || "";
        const orId = params.get("or_id") || "";
        const type = params.get("type") || "cheque";

        // Set payment type
        const validTypes = ["cheque", "fpx", "online_banking"];
        setActiveType(validTypes.includes(type) ? type : "cheque");

        if (isTermResubmit) {
          const reason = sessionStorage.getItem("term_reject_reason") || "";
          setRejectReason(reason);
        }

        // Fetch bank data
        const bankResponse = await ApiService.payByChequeIBG({
          selected_ids: ids,
          selected_so: orderIds,
        });

        // Check if we got a valid response with the expected structure
        if (
          !bankResponse ||
          bankResponse.status !== 200 ||
          !bankResponse.data
        ) {
          throw new Error(getErrMsg(bankResponse, "Failed to get bank data"));
        }

        // Extract bank data with explicit checks
        const myBankList = bankResponse.data.my_bank_list || [];
        const bankList = bankResponse.data.bank_list || [];

        // Create a new payment data object to use for all scenarios
        const newPaymentData = {
          my_bank_list: myBankList,
          bank_list: bankList,
          total_payment: "0.00",
          selected_invoices: [],
        };

        if (cartIds) {
          const checkoutRes = await ApiService.getCheckoutDetail(
            cartIds,
            pricingType,
          );
          if (checkoutRes.status === 200 && checkoutRes.data) {
            setCheckoutData(checkoutRes.data);
            setPaymentData({
              my_bank_list: [],
              bank_list: [],
              total_payment: checkoutRes.data.total ?? "0.00",
              selected_invoices: [
                {
                  inv_no: "CART",
                  amount: checkoutRes.data.total ?? "0.00",
                  cn_list: [],
                },
              ],
            });
          } else {
            // NEW: surface the real error instead of failing silently
            setErrorMessage(
              getErrMsg(checkoutRes, "Failed to load checkout details"),
            );
            setLoading(false);
            return;
          }
        }

        if (orId) {
          const orDetailRes = await ApiService.getUpdateORDetail(orId);
          if (orDetailRes.status === 200 && Array.isArray(orDetailRes.data)) {
            setCheckoutData(orDetailRes.data);
            const orInvoices = orDetailRes.data.map((item) => ({
              inv_no: item.invoice,
              amount: item.amount,
              cn_list: [],
            }));
            setPaymentData({
              my_bank_list: myBankList,
              bank_list: bankList,
              total_payment: orDetailRes.total_amount || "0.00",
              reject_reason: orDetailRes.reject_reason || "",
              selected_invoices: orInvoices,
            });
            if (myBankList && myBankList.length > 0) {
              setSelectedUnityBank({
                value: myBankList[0].id,
                label: myBankList[0].bank_name,
              });
            }
            return; // 直接 return，避免后面再 setPaymentData(newPaymentData)
          } else {
            // NEW: surface the real error instead of falling through silently
            setErrorMessage(
              getErrMsg(orDetailRes, "Failed to load official receipt details"),
            );
            setLoading(false);
            return;
          }
        }

        // Handle different payment sources
        if (ids || orderIds) {
          const isOrderPayment = !!orderIds;
          setPaymentSource(isOrderPayment ? "order" : "invoice");

          if (
            !isOrderPayment &&
            bankResponse.data.selected_invoices?.length > 0
          ) {
            newPaymentData.selected_invoices =
              bankResponse.data.selected_invoices;
            newPaymentData.total_payment =
              bankResponse.data.total_payment || "0.00";
          } else if (isOrderPayment) {
            const rawSoList = bankResponse.data.selected_so;
            const soList = Array.isArray(rawSoList)
              ? rawSoList
              : rawSoList && typeof rawSoList === "object"
                ? Object.values(rawSoList)
                : [];
            const invoiceData = soList.map((so) => ({
              inv_no: so.so_id,
              amount: so.total_amount,
            }));
            const orderAmount = soList.reduce(
              (sum, so) => sum + parseFloat(so.total_amount || 0),
              0,
            );

            newPaymentData.selected_invoices = invoiceData;
            newPaymentData.total_payment = orderAmount;
            setSelectedInvoices(invoiceData);
          }
        } else if (cartIds || orId) {
          setErrorMessage("");
        } else {
          setErrorMessage("No payment information provided");
        }

        if (orderIds) {
          setPaymentCompletionType("order");
        } else if (bankResponse.data.selected_invoices?.length > 0) {
          const allFullyDeducted = bankResponse.data.selected_invoices.every(
            (inv) => {
              const amount = inv.amount ? parseFloat(inv.amount) : 0;
              const cnTotal = Array.isArray(inv.cn_list)
                ? inv.cn_list.reduce(
                    (sum, cn) => sum + (cn.amount ? parseFloat(cn.amount) : 0),
                    0,
                  )
                : 0;
              return amount - cnTotal <= 0;
            },
          );
          setPaymentCompletionType(allFullyDeducted ? "full_cn" : "partial");
        }

        // Set payment data state once with all information
        setPaymentData(newPaymentData);

        // Set default unity bank outside any conditionals
        if (myBankList && myBankList.length > 0) {
          setSelectedUnityBank({
            value: myBankList[0].id,
            label: myBankList[0].bank_name,
          });
        }
      } catch (error) {
        console.error("Error in fetchData:", error);
        // UPDATED: use getErrMsg so real backend messages surface,
        // not just JS Error.message
        setErrorMessage(
          getErrMsg(error, "An error occurred while fetching payment details"),
        );
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [location.search]);

  useEffect(() => {
    if (showLoading && fpxFormData) {
      const timer = setTimeout(() => {
        const form = document.createElement("form");
        form.action = fpxFormData.redirect_url;
        form.method = "POST";
        form.style.display = "none";
        Object.entries(fpxFormData.fpx_form).forEach(([key, value]) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showLoading, fpxFormData]);

  const getMaxFiles = () => {
    if (parseFloat(paymentData.total_payment) === 0) return 0;
    if (paymentCompletionType === "order") return 5;
    return 1;
  };

  const handleBankTypeChange = async (type) => {
    setBankType(type);
    setShowFpxBank(true);
    try {
      const result = await ApiService.getFpxPaymentLink(type);
      // 保险处理，确保是数组
      const bankListObj = result.data.bank_list || {};
      const banks = Object.entries(bankListObj).map(([code, name]) => ({
        value: code,
        label: name,
      }));
      setFpxBankList(banks);
      // set FPX status (online/offline) from API
      setFpxStatus(result.data?.fpx_status || "online");
      // if (banks.length > 0) {
      //   setSelectedBank(banks[0]);
      // } else {
      //   setSelectedBank(null);
      // }
    } catch (error) {
      setFpxBankList([]);
    }
  };

  const unityBankOptions = [
    ...(paymentData.my_bank_list || []).map((bank) => ({
      value: bank.id,
      label: bank.bank_name,
    })),
  ];

  const bankOptions = [
    ...(paymentData.bank_list || []).map((bank) => ({
      value: bank.name,
      label: bank.name,
    })),
  ];

  const isOrder = paymentSource === "order";
  const isAllTermCnFull =
    paymentData.selected_invoices.length > 0 &&
    paymentData.selected_invoices.every((inv) => {
      if (inv.term_type === "term") {
        const amount = inv.amount ? parseFloat(inv.amount) : 0;
        const cnTotal = Array.isArray(inv.cn_list)
          ? inv.cn_list.reduce(
              (sum, cn) => sum + (cn.amount ? parseFloat(cn.amount) : 0),
              0,
            )
          : 0;
        return amount - cnTotal <= 0;
      }
      return false;
    });

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    const maxFiles = getMaxFiles();

    if (maxFiles === 0) {
      setErrorMessage("Files upload is not required for this payment.");
      return;
    }

    if (files.length > 0) {
      if (uploadedFiles.length + files.length > maxFiles) {
        setErrorMessage(
          `You can upload a maximum of ${maxFiles} file${
            maxFiles > 1 ? "s" : ""
          }.`,
        );
        return;
      }

      const validFiles = files.filter(
        (file) =>
          file.type === "application/pdf" || file.type.startsWith("image/"),
      );

      if (validFiles.length !== files.length) {
        setErrorMessage("Only image or PDF files are allowed.");
        return;
      }

      setUploadedFiles((prev) => [...prev, ...validFiles]);
      setErrorMessage("");
      setErrors((prev) => ({ ...prev, upload: "" }));
    }
  };

  // Payment submission handlers
  const handleSubmitPayment = async () => {
    console.debug("handleSubmitPayment called", {
      activeType,
      bankType,
      selectedBank,
    });
    const maxFiles = getMaxFiles();
    let newErrors = {
      unityBank: "",
      paymentBank: "",
      chequeNo: "",
      chequeDate: "",
      upload: "",
    };
    let hasError = false;

    if (!selectedUnityBank || selectedUnityBank.value === "") {
      newErrors.unityBank = "Please select a Unity bank";
      hasError = true;
    }
    if (activeType === "cheque" || activeType === "fpx") {
      if (!selectedBank || selectedBank.value === "") {
        newErrors.paymentBank = "Please select your payment bank";
        hasError = true;
      }
    }
    if (activeType === "cheque") {
      if (!document.getElementById("cheque_no")?.value) {
        newErrors.chequeNo = "Please enter the cheque number";
        hasError = true;
      }
      if (!value) {
        newErrors.chequeDate = "Please select a cheque date";
        hasError = true;
      }
    }

    if (activeType === "cheque" || activeType === "online_banking") {
      if (!value) {
        newErrors.chequeDate = "Please select a date";
        hasError = true;
      }
    }
    if (
      (activeType === "cheque" || activeType === "online_banking") &&
      uploadedFiles.length === 0 &&
      getMaxFiles() > 0
    ) {
      newErrors.upload = "Please upload at least one receipt";
      hasError = true;
    }

    setErrors(newErrors);
    if (hasError) return;

    // Check for uploaded files
    if (paymentCompletionType === "full_cn") {
      await handleCNPayment();
      return;
    } else if (
      (activeType === "cheque" || activeType === "online_banking") &&
      uploadedFiles.length === 0 &&
      maxFiles > 0
    ) {
      setErrorMessage("Please upload at least one receipt");
      return;
    }
    setIsSubmitting(true);
    setErrorMessage("");
    if (location.search.includes("or_id=")) {
      // 只处理 official receipt resubmit
      const params = new URLSearchParams(location.search);
      const or_id = params.get("or_id");
      const payment_type = "BANK IN";
      const bankin_date = value ? value.toISOString().split("T")[0] : "";
      const payment_file = uploadedFiles[0];

      const res = await ApiService.updateOfficialReceipt({
        or_id,
        payment_type,
        bankin_date,
        payment_file,
        unityBank: selectedUnityBank.value,
      });

      let payload = {
        or_id,
        payment_type,
        bankin_date,
        payment_file,
        unityBank: selectedUnityBank.value,
      };

      if (res.status) {
        setModalTitle("Upload Success");
        setModalMessage("Your bank slip has been uploaded!");
        setModalOpen(true);
        setModalLink("/mypaymenthistory");
      } else {
        setModalTitle("Upload Failed");
        setModalMessage(res.message || "Upload failed, please try again.");
        setModalOpen(true);
        setModalLink("/mypaymenthistory");
      }
      return;
    }
    try {
      if (paymentCompletionType === "order") {
        const params = new URLSearchParams(location.search);
        const orderIds = params.get("orders") || "";
        if (orderIds) {
          // 检查 payment_block
          const res = await ApiService.confirmPaymentChecking({
            type: "so",
            chk_no: orderIds,
          });
          if (res.status === 400) {
            setModalTitle("Payment Blocked");
            setModalMessage(
              res.message || "Payment is in progress, cannot continue.",
            );
            setModalOpen(true);
            setModalLink("/allorder");
            setIsSubmitting(false);
            return;
          }
        }

        await handleOrderPayment();
      } else {
        await handleTermPayment();
      }
    } catch (error) {
      console.error("Payment submission error:", error);
      setErrorMessage(
        error.message || "Failed to process payment. Please try again.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFPXPayment = async () => {
    console.debug("handleFPXPayment called", {
      activeType,
      bankType,
      selectedBank,
    });
    if (!bankType) {
      setErrors({
        ...errors,
        bankType: "Please select Personal or Corporate Banking.",
      });
      return;
    }
    if (!selectedBank || !selectedBank.value) {
      setErrors({ ...errors, paymentBank: "Please select your payment bank." });
      return;
    }
    setIsSubmitting(true);
    setErrorMessage("");
    try {
      const params = new URLSearchParams(location.search);
      const cartIds = params.get("cart_ids") || "";
      const orders = params.get("orders") || "";
      const ids = params.get("ids") || "";
      //const pricingType = params.get("pricing_type") || "";
      const fastpay = params.get("fastpay");
      let fpxParams = {
        payment_type: "fpx",
        h_account_type: bankType,
        h_bank_id: selectedBank?.value,
      };

      if (cartIds) {
        fpxParams.link_from = "1";
        fpxParams.available_id = cartIds;
        fpxParams.pricing_type = pricingType;
        fpxParams.checkout_message = checkoutMessage;
        fpxParams.salesman_opt = salesmanOpt;
        fpxParams.option = option;
        fpxParams.einvoice_data = extraEinvoiceData;
        fpxParams.cash_pay = fastpay === "1" ? 1 : 0;
        if (fastpay === 1 || fastpay === "1") {
          fpxParams.fast_payment =
            checkoutData.fastpayment_discount_total || "0.00";
        } else {
          fpxParams.fast_payment = 0;
        }
      } else if (orders) {
        fpxParams.link_from = "2";
        fpxParams.so_list = orders;
      } else if (ids) {
        fpxParams.link_from = "3";
        fpxParams.inv_list = ids;
      }
      //console.log("FPX Params:", fpxParams);
      const response = await ApiService.fpxPaid(fpxParams);
      if (
        response &&
        response.status === 200 &&
        response.data?.redirect_url &&
        response.data?.fpx_form
      ) {
        setShowLoading(true);
        // 保存 response 到 state
        setFpxFormData(response.data);
        return; // 不立即跳转
        // 创建并自动提交表单
        const form = document.createElement("form");
        form.action = response.data.redirect_url;
        form.method = "POST";
        form.style.display = "none";

        // fpx_form 是对象，遍历添加 hidden input
        Object.entries(response.data.fpx_form).forEach(([key, value]) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
      } else {
        setErrorMessage(response?.message || "FPX payment failed.");
      }
    } catch (error) {
      setErrorMessage(error.message || "FPX payment failed.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCNPayment = async () => {
    try {
      const params = new URLSearchParams(location.search);
      const urlIds = params.get("ids") || "";

      const response = await ApiService.confirmPayByCN({
        inv_list: urlIds,
      });

      if (response && response.status === 200) {
        setModalVariant("success");
        setModalTitle("Payment Success");
        setModalMessage("Your payment was successful!");
        setModalOpen(true);
        setModalLink("/allorder");
      } else {
        setModalTitle("Payment Failed");
        setModalMessage(
          response?.message || "Payment failed, please try again.",
        );
        setModalOpen(true);
        setModalLink("/allorder");
        console.error("Payment submission error:", response);
      }
    } catch (error) {
      alert(error);
      console.error("Payment submission error:", error);
    }
  };

  const handleTermPayment = async () => {
    try {
      const formData = new FormData();
      formData.append("unity_bank", selectedUnityBank.value);
      formData.append("payment_type", activeType);

      const params = new URLSearchParams(location.search);
      const urlIds = params.get("ids") || "";
      formData.append("inv_list", urlIds);

      if (activeType === "cheque") {
        formData.append("payment_bank", selectedBank.value);
        formData.append(
          "cheque_no",
          document.getElementById("cheque_no").value,
        );
        formData.append(
          "cheque_date",
          value ? value.toISOString().split("T")[0] : "",
        );
        formData.append("cheque_amount", paymentData.total_payment);
      } else if (activeType === "online_banking") {
        formData.append("posting_date", new Date().toISOString().split("T")[0]);
        formData.append("paid_total_amount", paymentData.total_payment);
      }

      // 只上传一个文件给term payment
      if (uploadedFiles.length > 0) {
        formData.append("payment_file", uploadedFiles[0]);
      }

      const response = await ApiService.confirmPayByChequeIBGTerm(formData);

      if (response && response.status === 200) {
        setModalVariant("success");
        setModalTitle("Payment Success");
        setModalMessage("Your payment was successful!");
        setModalOpen(true);
        setModalLink("/allorder");
      } else {
        setModalTitle("Payment Failed");
        setModalMessage(
          response?.message || "Payment failed, please try again.",
        );
        setModalOpen(true);
        setModalLink("/allorder");
        console.error("Payment submission error:", response);
      }
    } catch (error) {
      alert(error);
      console.error("Payment submission error:", error);
    }
  };

  const handleOrderPayment = async () => {
    try {
      const formData = new FormData();
      formData.append("unity_bank", selectedUnityBank.value);
      formData.append("payment_type", activeType);

      const params = new URLSearchParams(location.search);
      const orderIds = params.get("orders") || "";
      formData.append("so_id", orderIds);
      if (activeType === "cheque") {
        formData.append("payment_bank", selectedBank.value);
        formData.append(
          "cheque_no",
          document.getElementById("cheque_no").value,
        );
        formData.append(
          "cheque_date",
          value ? value.toISOString().split("T")[0] : "",
        );
        formData.append("cheque_amount", paymentData.total_payment);
      } else if (activeType === "online_banking") {
        formData.append("posting_date", new Date().toISOString().split("T")[0]);
        formData.append("cheque_amount", paymentData.total_payment);
      }

      // 为订单支付上传多个文件
      uploadedFiles.forEach((file, index) => {
        formData.append(
          index === 0 ? "payment_file" : `payment_file_${index + 1}`,
          file,
        );
      });

      const response = await ApiService.confirmPayByChequeIBGCBD(formData);

      const respData = response?.data;
      const isSuccessful =
        response &&
        response.status === 200 &&
        respData &&
        (respData.status === 200 ||
          respData.status === 1 ||
          respData.status === true);

      if (isSuccessful) {
        setModalVariant("success");
        setModalTitle("Payment Success");
        setModalMessage("Your payment was successful!");
        setModalOpen(true);
        setModalLink("/allorder");
      } else {
        let message =
          respData?.message ||
          response?.message ||
          "Payment failed, please try again.";
        if (
          respData &&
          Array.isArray(respData.invalid_orders) &&
          respData.invalid_orders.length
        ) {
          const details = respData.invalid_orders
            .map((o) => `${o.so_id}: ${o.reason}`)
            .join("; ");
          message = `${message} (${details})`;
        }

        setModalVariant("");
        setModalTitle("Payment Failed");
        setModalMessage(message);
        setModalOpen(true);
        setModalLink("/allorder");
        console.error("Payment submission error:", response);
      }
    } catch (error) {
      alert(error);
      console.error("Payment submission error:", error);
    }
  };

  // Component for the upload receipt section (used in both cheque and online banking)
  const UploadReceiptSection = () => {
    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState({});
    const maxFiles = getMaxFiles();

    if (maxFiles === 0) {
      return (
        <div className="upload-receipt-section_v2">
          <div className="no-upload-required">
            <div className="success-message_v2">
              Payment completed using Credit Note. No receipt upload required.
            </div>
          </div>
        </div>
      );
    }
    // Handle file upload
    const handleUpload = (event) => {
      const files = Array.from(event.target.files);

      if (files.length > 0) {
        // Check if adding these files would exceed the 5 file limit
        if (uploadedFiles.length + files.length > 5) {
          setErrorMessage(`You can upload a maximum of 5 files.`);
          return;
        }

        // Validate file types
        const validFiles = files.filter(
          (file) =>
            file.type === "application/pdf" || file.type.startsWith("image/"),
        );

        if (validFiles.length !== files.length) {
          setErrorMessage("Only image or PDF files are allowed.");
          return;
        }

        // Simulate upload progress for each file
        setIsUploading(true);
        validFiles.forEach((file) => {
          setUploadProgress((prev) => ({
            ...prev,
            [file.name]: 0,
          }));

          // Simulate progress
          const interval = setInterval(() => {
            setUploadProgress((prev) => {
              const currentProgress = prev[file.name] || 0;
              const newProgress = Math.min(currentProgress + 10, 100);

              if (newProgress >= 100) {
                clearInterval(interval);
                setIsUploading(false);
              }

              return {
                ...prev,
                [file.name]: newProgress,
              };
            });
          }, 300);
        });

        // Add new files to existing files
        setUploadedFiles((prev) => [...prev, ...validFiles]);

        // Also set uploadedFile for backward compatibility
        if (files.length > 0) {
          setUploadedFile(files[0]);
        }

        setErrorMessage("");
      }
    };

    // Handle file removal
    const removeFile = (e, indexToRemove) => {
      e.stopPropagation(); // Prevent opening preview when removing

      setUploadedFiles((files) => {
        const newFiles = files.filter((_, index) => index !== indexToRemove);

        // Also remove progress data
        const fileToRemove = files[indexToRemove];
        if (fileToRemove) {
          setUploadProgress((prev) => {
            const newProgress = { ...prev };
            delete newProgress[fileToRemove.name];
            return newProgress;
          });
        }

        return newFiles;
      });
    };

    // Get file extension from name
    const getFileExtension = (filename) => {
      return filename.split(".").pop().toLowerCase();
    };

    // clicking uploaded card should not open preview; no-op
    const openFilePreview = (file) => {};

    return (
      <div className="upload-receipt-section_v2">
        <div className="upload-block_v2">
          <div className="upload-label_v2">
            Payment Receipt <span style={{ color: "#d40e0e" }}>*</span>
          </div>

          <div className="upload-box-wrapper_v2">
            <div className="upload-cards_v2">
              {/* Render uploaded thumbnails as fixed cards */}
              {uploadedFiles.map((file, index) => {
                const ext = getFileExtension(file.name);
                const isImage = file.type && file.type.startsWith("image/");
                const previewStyle = isImage
                  ? { backgroundImage: `url(${URL.createObjectURL(file)})` }
                  : {};
                return (
                  <div key={index} className={`upload-card_v2 has-file`}>
                    {isImage ? (
                      <div
                        className={`upload-card-thumb_v2`}
                        style={{
                          backgroundImage: `url(${URL.createObjectURL(file)})`,
                        }}
                      />
                    ) : (
                      <div
                        className={`upload-card-thumb_v2 upload-card-file_v2`}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <FileText
                            size={46}
                            className="upload-card-fileicon_v2"
                          />
                          <div className="upload-card-filelabel_v2">
                            {ext.toUpperCase()}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="upload-card-overlay_v2">
                      <div className="upload-card-name_v2" title={file.name}>
                        {file.name}
                      </div>
                      <div className="upload-card-size_v2">
                        {formatFileSize(file)}
                      </div>
                    </div>

                    <button
                      className="upload-card-remove_v2"
                      onClick={(e) => {
                        e.stopPropagation();
                        removeFile(e, index);
                      }}
                      title="Remove"
                      aria-label={`Remove ${file.name}`}
                    >
                      <X size={14} color="#fff" />
                    </button>
                  </div>
                );
              })}

              {/* Add card */}
              {uploadedFiles.length < (maxFiles || 1) && (
                <label
                  className="upload-card_v2 upload-card-empty_v2"
                  htmlFor="file-upload"
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <Upload size={28} className="upload-card-addicon_v2" />
                    <div className="upload-card-addtext_v2">
                      Click to upload
                    </div>
                  </div>
                </label>
              )}

              <input
                id="file-upload"
                type="file"
                accept="image/*,.pdf"
                onChange={handleFileUpload}
                style={{ display: "none" }}
                multiple={maxFiles > 1}
              />
            </div>

            <div
              className="upload-hint_v2"
              style={errors.upload ? { color: "#d40e0e" } : {}}
            >
              {errors.upload
                ? errors.upload
                : "Upload your bank transfer receipt or confirmation slip"}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const nettPayTotal = paymentData.selected_invoices
    ? paymentData.selected_invoices.reduce((sum, invoice) => {
        const amountToPay = invoice.amount ? parseFloat(invoice.amount) : 0;
        const cnTotal = invoice.cn_list
          ? invoice.cn_list.reduce(
              (cnSum, cn) => cnSum + (cn.amount ? parseFloat(cn.amount) : 0),
              0,
            )
          : 0;
        return sum + Math.max(0, amountToPay - cnTotal);
      }, 0)
    : 0;

  const hasFastPayDiscount =
    location.search.includes("fastpay=1") &&
    checkoutData?.fast_payment_detail?.discount;

  const discountedTotal = hasFastPayDiscount
    ? checkoutData?.total -
      checkoutData?.total * (checkoutData?.fast_payment_detail?.discount / 100)
    : checkoutData?.total;

  return (
    <>
      {loading ? (
        <div className="uc-container_v2">
          <div className="loading-container_v2">
            <div className="loading-spinner"></div>
            <p>Loading payment details...</p>
          </div>
        </div>
      ) : showLoading ? (
        <Loading />
      ) : (
        <div className={`uploadcheque_v2 paymentSource-${paymentSource}`}>
          <div className="uploadcheque-content_v2">
            <div className="ulcheque-title-container_v2">
              <div className="ulcheque-title_v2">
                <div
                  className="ucback-button"
                  onClick={() => {
                    navigate(-1);
                    sessionStorage.removeItem("term_reject_reason");
                  }}
                >
                  <ArrowLeft size={24} style={{ cursor: "pointer" }} />
                </div>
                <div>
                  <strong>
                    {activeType === "fpx"
                      ? `Payment Gateway - FPX${fpxStatus === "offline" ? " (currently offline)" : ""}`
                      : activeType === "online_banking"
                        ? "Payment Gateway - Interbank GIRO (IBG)"
                        : "UPLOAD CHEQUE RECEIPT"}
                  </strong>
                </div>
              </div>
            </div>

            {/* Error message display */}
            <div className="uc-container_v2">
              {errorMessage && (
                <div className="error-message_v2" style={{ color: "#d40e0e" }}>
                  {errorMessage}
                </div>
              )}

              {location.search.includes("or_id=") && (
                <div className="reject-reason-box_v2">
                  <span className="reject-reason-title_v2">
                    Resubmit Receipt
                  </span>
                  <div
                    className="reject-reason-content_v2"
                    style={{ color: "#b71c1c" }}
                  >
                    Reject Reason: {paymentData.reject_reason}
                  </div>
                </div>
              )}

              {isTermResubmit && (
                <div className="reject-reason-box_v2">
                  <span className="reject-reason-title_v2">
                    Resubmit Term Order
                  </span>
                  <div
                    className="reject-reason-content_v2"
                    style={{ color: "#b71c1c" }}
                  >
                    Reject Reason: {rejectReason}
                  </div>
                </div>
              )}

              <div className="uc-grid_v2">
                <div className="uc-main_v2">
                  {/* Payment summary moved to right sidebar */}

                  <div className="bank-detail_v2 bank-detail-card_v2">
                    <div className="card-header_v2">
                      Beneficiary Information
                    </div>
                    <div className="card-body_v2">
                      {paymentData.my_bank_list &&
                        paymentData.my_bank_list.map((bank) => (
                          <div key={bank.id} className="bank-detail-entry_v2">
                            <div className="bankdetail-info_v2">
                              <span className="ulcheque-subtitle_v2">
                                Account Holder
                              </span>
                              <div className="ulcheque-colon_v2">:</div>
                              <strong className="bank-value_v2">
                                {bank.name}
                              </strong>
                            </div>
                            <div className="bankdetail-info_v2">
                              <span className="ulcheque-subtitle_v2">
                                Bank Institution
                              </span>
                              <div className="ulcheque-colon_v2">:</div>
                              <span className="bank-value_v2">
                                {bank.bank_name}
                              </span>
                            </div>

                            <div
                              className="bankdetail-info_v2"
                              style={{ marginBottom: 0 }}
                            >
                              <span className="ulcheque-subtitle_v2">
                                Account Number
                              </span>
                              <div className="ulcheque-colon_v2">:</div>
                              <strong className="bank-value_v2">
                                {bank.account_no}
                              </strong>
                            </div>
                          </div>
                        ))}

                      {(!paymentData.my_bank_list ||
                        paymentData.my_bank_list.length === 0) && (
                        <div className="no-banks-message">
                          No bank details available
                        </div>
                      )}
                    </div>
                  </div>

                  {/* CHEQUE PAYMENT SECTION */}
                  {/* {activeType === "cheque" && (
            <div className="cheque-info">
              <div className="bank-container_v2">
                <div className="cheque-unitybank_v2">
                  <div>
                    Unity Bank
                    <CustomDropdown
                      options={unityBankOptions}
                      value={selectedUnityBank ? selectedUnityBank.value : ""}
                      onChange={(val, opt) => setSelectedUnityBank(opt)}
                      placeholder="Please select a unity bank"
                      className="uploadcheque-dropdown_v2"
                    />
                  </div>
                  {errors.unityBank && (
                    <div
                      className="error-message"
                      style={{ color: "red", marginTop: 4 }}
                    >
                      {errors.unityBank}
                    </div>
                  )}
                </div>
                <div className="cheque-paymentbank_v2">
                  <div>
                    Payment Bank
                    <CustomDropdown
                      options={bankOptions}
                      value={selectedBank ? selectedBank.value : ""}
                      onChange={(val, opt) => setSelectedBank(opt)}
                      placeholder="Please select your payment bank"
                      className="uploadcheque-dropdown_v2"
                    />
                  </div>
                  {errors.paymentBank && (
                    <div
                      className="error-message"
                      style={{ color: "red", marginTop: 4 }}
                    >
                      {errors.paymentBank}
                    </div>
                  )}
                </div>
              </div>

              <div className="cheque-container">
                <div className="chequeno">
                  <div>
                    Cheque No <br />
                    <input id="cheque_no" placeholder="Enter cheque no" />
                  </div>
                  {errors.chequeNo && (
                    <div
                      className="error-message"
                      style={{ color: "red", marginTop: 4 }}
                    >
                      {errors.chequeNo}
                    </div>
                  )}
                </div>
                <div className="chequedate">
                  <strong>CHEQUE DATE</strong>
                  <div className="ulcheque-date-picker-container">
                    <input
                      type="text"
                      className="ulcheque-date-range-input"
                      readOnly
                      value={value ? value.toLocaleDateString() : ""}
                      placeholder="Select bank in date"
                      onClick={() => setCalendarOpen((open) => !open)}
                    />
                    {value && (
                      <X
                        size={16}
                        style={{
                          marginLeft: 8,
                          color: "#aaa",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          onChange(null);
                        }}
                      />
                    )}
                    <LucideCalendar
                      size={22}
                      style={{ cursor: "pointer" }}
                      onClick={() => setCalendarOpen((open) => !open)}
                    />
                    {calendarOpen && (
                      <div className="calendar_v2" onClick={(e) => e.stopPropagation()}>
                        <Calendar
                          onChange={(date) => {
                            onChange(date);
                            setCalendarOpen(false);
                          }}
                          value={value}
                        />
                      </div>
                    )}
                  </div>
                  {errors.chequeDate && (
                    <div
                      className="error-message"
                      style={{ color: "red", marginTop: 4 }}
                    >
                      {errors.chequeDate}
                    </div>
                  )}
                </div>
              </div>
              <UploadReceiptSection />
              
              <div className="upload-button-container">
                <button className="upload-button" onClick={handleSubmitPayment}>
                  {isSubmitting ? "PROCESSING..." : "CONFIRM PAYMENT"}
                </button>
              </div>
            </div>
          )} */}

                  {/* FPX PAYMENT SECTION */}
                  {activeType === "fpx" && (
                    <div className="fpx-info">
                      <div className="payment-detail_v2 payment-detail-card_v2">
                        <div className="card-header_v2">
                          Select Payment Method
                        </div>
                        <div className="card-body_v2">
                          <div className="payment-title_v2">
                            <div className="payment-method_v2">
                              <div className="method-icon_v2 icon-fpx_v2">
                                <img
                                  src={FPX}
                                  alt="FPX"
                                  style={{ height: 28 }}
                                />
                              </div>
                              <div className="payment-method-info_v2">
                                <div className="payment-method-sub_v2 single-line_v2">
                                  Financial Process Exchange
                                </div>
                              </div>
                            </div>
                          </div>

                          {fpxStatus === "offline" && (
                            <div
                              className="fpx-offline-banner_v2"
                              style={{
                                backgroundColor: "#fff3f3",
                                color: "#b71c1c",
                                padding: "10px 12px",
                                borderRadius: 8,
                                marginTop: 8,
                                marginBottom: 8,
                              }}
                            >
                              Currently offline — FPX payments unavailable.
                              Please choose another payment method.
                            </div>
                          )}

                          <div className="payment-info_v2">
                            <div className="bank-container_v2 bank-full_v2">
                              <label
                                className={`personalbank_v2 ${bankType === "01" ? "selected" : ""}`}
                              >
                                <input
                                  type="radio"
                                  name="bankType"
                                  value="01"
                                  checked={bankType === "01"}
                                  onChange={() =>
                                    handleBankTypeChange(
                                      "01",
                                      setErrors({ ...errors, bankType: "" }),
                                    )
                                  }
                                  disabled={fpxStatus === "offline"}
                                />
                                <CreditCard
                                  size={18}
                                  className="method-option-icon_v2"
                                />
                                <div>
                                  <span className="bank-card-content_v2">
                                    Individual Account
                                  </span>
                                  <div className="bank-card-sub_v2">
                                    Personal banking account
                                  </div>
                                </div>
                              </label>
                              <label
                                className={`corporatebank_v2 ${bankType === "02" ? "selected" : ""}`}
                              >
                                <input
                                  type="radio"
                                  name="bankType"
                                  value="02"
                                  checked={bankType === "02"}
                                  onChange={() =>
                                    handleBankTypeChange(
                                      "02",
                                      setErrors({ ...errors, bankType: "" }),
                                    )
                                  }
                                  disabled={fpxStatus === "offline"}
                                />
                                <Building2
                                  size={18}
                                  className="method-option-icon_v2"
                                />
                                <div>
                                  <span className="bank-card-content_v2">
                                    Business Account
                                  </span>
                                  <div className="bank-card-sub_v2">
                                    Corporate banking account
                                  </div>
                                </div>
                              </label>
                            </div>
                          </div>
                          {errors.bankType && (
                            <div
                              className="error-message_v2"
                              style={{ color: "red" }}
                            >
                              {errors.bankType}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="payment-detail_v2 payment-detail-card_v2">
                        <div className="card-header_v2">
                          Select Banking Institution
                        </div>
                        <div className="card-body_v2">
                          <div className="choose-bank-label">
                            Choose Your Bank
                          </div>
                          <div style={{ marginTop: 12, width: "100%" }}>
                            <CustomDropdown
                              options={fpxBankList}
                              value={selectedBank ? selectedBank.value : ""}
                              onChange={(val, opt) => setSelectedBank(opt)}
                              placeholder="Please select your banking institution"
                              className="uploadcheque-dropdown_v2"
                              isDisabled={!bankType || fpxStatus === "offline"}
                            />
                          </div>
                          {errors.paymentBank && (
                            <div
                              className="error-message_v2"
                              style={{ color: "red" }}
                            >
                              {errors.paymentBank}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="important-note_v2 fpx-important-note_v2">
                        <div className="important-icon_v2 fpx-important-icon_v2">
                          <Info size={20} />
                        </div>
                        <div>
                          By proceeding with this transaction, you acknowledge
                          and agree to the{" "}
                          <a
                            href="https://www.mepsfpx.com.my/FPXMain/termsAndConditions.jsp"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            FPX's Terms and Conditions
                          </a>
                          &nbsp;and authorize the deduction of the payment
                          amount from your selected account.
                        </div>
                      </div>
                    </div>
                  )}

                  {/* ONLINE BANKING SECTION */}
                  {activeType === "online_banking" && (
                    <div className="online-banking-info">
                      <div className="payment-detail_v2 payment-detail-card_v2">
                        <div className="card-header_v2">Payment Details</div>
                        <div className="card-body_v2">
                          <div className="payment-title_v2">
                            <div className="payment-method_v2">
                              <div className="method-icon_v2">IBG</div>
                              <div className="payment-method-info_v2">
                                <div className="payment-method-name_v2">
                                  Interbank GIRO Transfer
                                </div>
                                <div className="payment-method-sub_v2">
                                  Direct bank transfer method
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="payment-amount-card_v2">
                            <div className="amount-label_v2">
                              Payment Amount
                            </div>
                            <div className="amount-value_v2">
                              <span className="payment-amount-highlight_v2">
                                RM{" "}
                                {paymentData.total_payment
                                  ? formatCurrency(paymentData.total_payment)
                                  : "0.00"}
                              </span>
                            </div>
                          </div>

                          <div className="posting-date-row_v2">
                            <label className="posting-date-label_v2">
                              Transaction Posting Date{" "}
                              <span style={{ color: "#d40e0e" }}>*</span>
                            </label>
                            <div
                              className="posting-date-input-wrapper_v2"
                              onClick={() => setCalendarOpen((open) => !open)}
                            >
                              <div className="posting-date-icon_v2">
                                <LucideCalendar size={18} />
                              </div>
                              <input
                                type="text"
                                className="posting-date-input_v2"
                                readOnly
                                value={
                                  value
                                    ? new Date(value).toLocaleDateString(
                                        "en-MY",
                                        {
                                          day: "2-digit",
                                          month: "short",
                                          year: "numeric",
                                        },
                                      )
                                    : ""
                                }
                                placeholder="dd-----yyy"
                              />
                              {value && (
                                <X
                                  size={16}
                                  className="posting-date-clear_v2"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onChange(null);
                                  }}
                                />
                              )}
                              {calendarOpen && (
                                <div
                                  className="calendar_v2"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <Calendar
                                    onChange={(date) => {
                                      onChange(date);
                                      setCalendarOpen(false);
                                      setErrors((prev) => ({
                                        ...prev,
                                        chequeDate: "",
                                      }));
                                    }}
                                    value={value}
                                  />
                                </div>
                              )}
                            </div>
                            <div
                              className="posting-date-help_v2"
                              style={
                                errors.chequeDate ? { color: "#d40e0e" } : {}
                              }
                            >
                              {errors.chequeDate
                                ? errors.chequeDate
                                : "Please select the date when you made the transfer"}
                            </div>
                          </div>

                          <UploadReceiptSection />
                        </div>
                      </div>

                      <div className="important-note_v2">
                        <div className="important-icon_v2">
                          <Info size={20} />
                        </div>
                        <div>
                          Please ensure that the payment amount on your receipt
                          matches the total payable amount before proceeding
                          with confirmation.
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Sidebar */}
                <aside className="uc-sidebar_v2">
                  <div className="payment-summary-card_v2">
                    <div className="card-header_v2">Payment Summary</div>
                    <div className="card-body_v2">
                      <div className="summary-block_v2">
                        <div className="summary-label_v2">
                          Transaction Reference
                        </div>
                        <div className="summary-value_v2">
                          {params.get("orders") ||
                            params.get("ids") ||
                            params.get("or_id") ||
                            ""}
                        </div>
                      </div>

                      <div
                        className="summary-block_v2"
                        style={{
                          paddingTop: 16,
                          borderBottom: "2px solid #0000001a",
                          paddingBottom: 24,
                        }}
                      >
                        <div className="summary-label_v2">
                          Net Payment Amount
                        </div>
                        <div className="summary-value_v2">
                          RM{" "}
                          {checkoutData
                            ? formatCurrency(
                                hasFastPayDiscount
                                  ? discountedTotal
                                  : checkoutData.total,
                              )
                            : paymentData.total_payment
                              ? formatCurrency(paymentData.total_payment)
                              : "0.00"}
                        </div>
                      </div>

                      <div className="total-label_v2">Total Amount Payable</div>
                      <div className="total-amount_v2">
                        RM{" "}
                        {checkoutData
                          ? formatCurrency(
                              hasFastPayDiscount
                                ? discountedTotal
                                : checkoutData.total,
                            )
                          : paymentData.total_payment
                            ? formatCurrency(paymentData.total_payment)
                            : "0.00"}
                      </div>
                      <button
                        type="button"
                        className="confirm-button_v2"
                        onClick={
                          activeType === "fpx"
                            ? fpxStatus === "offline"
                              ? () =>
                                  setErrorMessage(
                                    "FPX is currently offline. Please choose another payment method.",
                                  )
                              : handleFPXPayment
                            : handleSubmitPayment
                        }
                        disabled={
                          isSubmitting ||
                          (activeType === "fpx" && fpxStatus === "offline")
                        }
                        title={
                          activeType === "fpx" && fpxStatus === "offline"
                            ? "FPX is currently offline"
                            : undefined
                        }
                      >
                        {isSubmitting ? "PROCESSING..." : "Confirm Payment"}
                      </button>
                      <div
                        className="cancel-link_v2"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        Cancel Transaction
                      </div>
                    </div>
                  </div>
                </aside>
              </div>

              {modalOpen && (
                <MultiPurpose
                  variant={modalVariant}
                  title={modalTitle}
                  message={modalMessage}
                  yesText={
                    modalVariant === "success" ? "Back to Shopping Cart" : "OK"
                  }
                  showYesLink={true}
                  yesLink={modalLink}
                  hideNo={true}
                  onYes={() => {
                    setModalOpen(false);
                    setModalVariant("");
                    navigate(modalLink);
                  }}
                  onClose={() => {
                    setModalOpen(false);
                    setModalVariant("");
                    navigate(modalLink);
                  }}
                />
              )}

              {showCreditNote && selectedCreditNote && (
                <CreditNote
                  data={selectedCreditNote}
                  onClose={() => setShowCreditNote(false)}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UploadChequev2;
